<template>
  <div class="todo-schedule-wrap">
    <div class="content-wrap">
      <div v-if="activeName === 'today'" class="today-task-create-task" @click="addNewTask"><i class="ibass ibass-add"></i>新建任务</div>
      <el-tabs v-model="activeName" @tab-click="handleClick(activeName)">
        <el-tab-pane name="today">
          <div slot="label">
            <span style="font-size: 12px;">今日任务</span>
            <span style="font-size: 12px;margin-left: 4px; color: #999999">{{taskDetail.count}}</span>
          </div>
          <div v-loading="loadingTask" style="min-height: 300px;" v-if="taskDetail.data && taskDetail.data.length > 0">
            <todo-task
              :taskData = taskDetail.data
              :isOvertime = isOvertime
            ></todo-task>
          </div>
          <div class="task-blank-text" v-if="showAddBtn" style="margin-top: 30px;text-align: center;font-size: 14px;">
            <span style="color:#8590a6">暂无待办任务，</span>
            <span style="color:#ed6c00;cursor: pointer" @click="addNewTask"><i class="ibass ibass-add" style="position:relative;top:2px;margin-right:3px;"></i>新建任务</span>
          </div>
        </el-tab-pane>
        <el-tab-pane  name="approve" v-if="officeType !== 'platform'">
          <div slot="label">
            <span style="font-size: 12px;">待办审批</span>
            <span style="font-size: 12px;margin-left: 4px; color: #999999">{{approListData.totalCount}}</span>
          </div>
          <div class="approve-blank-text" v-if="showBlankText" style="font-size: 14px; color: #8590a6; text-align: center; margin-top: 30px;">暂无待办审批</div>
          <div v-loading="loadingAppro" style="min-height: 300px;">
            <todo-approve
              v-if="approListData.items && approListData.items.length"
              :approData="approListData.items"
            ></todo-approve>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="more-button" v-if="activeName==='today' && taskDetail.data && taskDetail.data.length > 0" @click="goMoreTask">跳转我的任务，查看更多<em class="ibass ibass-arrow-next"></em></div>
      <div class="more-button" v-if="activeName==='approve' && approListData.items && approListData.items.length > 0" @click="goMoreApprove">跳转我的审批，查看更多<em class="ibass ibass-arrow-next"></em></div>
    </div>
  </div>
</template>

<script>
import Pservice from '../../service/index'
import timeUtils from '../../../../utils/time'
import TodoTask from './components/todoTask'
import TodoApprove from './components/todoApprove'
import '@/style/font-icon/style.css'
// import '@/style/font-one/icon-one.css'
export default {
  name: 'todoSchedule',
  components: {
    TodoTask,
    TodoApprove
  },
  data () {
    return {
      activeName: 'today',
      loadingTask: true,
      loadingAppro: false,
      showAddBtn: false,
      showBlankText: false,
      myUserId: '',
      taskDetail: {},
      taskItem: [],
      officeType: '',
      isNewFirm: '',
      isOvertime: false,
      approListData: {
        items: [],
        isMatterList: [10, 9, 8, 5, 7, 3, 6],
        typeInfos: {
          1: {
            type: '1',
            name: '发票',
            desc: '发票审批'
          },
          2: {
            type: '2',
            name: '报销',
            desc: '报销审批'
          },
          3: {
            type: '3',
            name: '结项',
            desc: '结项审批'
          },
          4: {
            type: '4',
            name: '合同',
            desc: '合同审批'
          },
          5: {
            type: '5',
            name: '立项',
            desc: '立项审批'
          },
          6: {
            type: '6',
            name: '重启项目',
            desc: '重启项目审批'
          },
          7: {
            type: '7',
            name: '编辑项目',
            desc: '编辑项目审批'
          },
          8: {
            type: '8',
            name: '预立项',
            desc: '预立项审批'
          },
          9: {
            type: '9',
            name: '编辑预立项',
            desc: '编辑预立项审批'
          },
          10: {
            type: '10',
            name: '预立项转进行中',
            desc: '预立项转进行中审批'
          },
          0: {
            type: '0',
            name: '盖章',
            desc: '盖章审批'
          }
        }
      }
    }
  },
  methods: {
    handleClick (tab) {
      if (tab === 'approve') {
        this.getApproList()
        this.$analysis.track('点击待办审批_待办事项/工作台模块')
      } else if (tab === 'today') {
        this.getTaskList()
        this.$analysis.track('点击待办任务_待办事项/工作台模块')
      }
    },
    goMoreTask () {
      window.parent.postMessage({
        action: 'fromWorkFlatMyTask'
      }, process.env.VUE_APP_IFRAME_DOMAIN)
      this.$analysis.track('点击跳转任务_待办事项/工作台模块')
    },
    goMoreApprove () {
      window.parent.postMessage({
        action: 'fromWorkFlatMyApproval',
        data: {
          type: 'approvals'
        }
      }, process.env.VUE_APP_IFRAME_DOMAIN)
      this.$analysis.track('点击跳转审批_待办事项/工作台模块')
    },
    addNewTask () {
      this.$postMessage.createTask(undefined, (data) => {
        if (data && data.status === 'success') {
          this.getTaskList()
        }
      })
    },
    async getTaskList () {
      let params = {
        userIds: this.myUserId,
        mpListType: 'TODAY',
        status: '1'
      }
      this.loadingTask = true
      try {
        const response = await Pservice.getTaskList(params)
        if (response.isSuccess) {
          response.data.data.map(item => {
            if (item.dueTime) {
              item.formatDueTime = timeUtils.formatTime(
                new Date(item.dueTime),
                item.dayType === 1 ? 'day' : 'daytime')
              item.isOvertime = timeUtils.initOverTime(item.dueTime)
            }
            if (item.endTime) {
              item.isOvertime = timeUtils.initOverTime(item.endTime)
              item.endTime = timeUtils.formatTime(
                new Date(item.endTime),
                item.dayType === 1 ? 'day' : 'daytime')
            }
          })
          this.taskDetail = response.data
          this.taskItem = response.data.data
          if (this.taskItem.length === 0) {
            this.showAddBtn = true
          } else {
            this.showAddBtn = false
          }
          this.loadingTask = false
        } else {
          this.loadingTask = false
          this.$postMessage.toast({ msg: response.message || response.resultMsg })
        }
      } catch (e) {
        this.loadingTask = false
      }
    },
    // 获取审批列表
    async getApproList () {
      let params = {
        approTypes: '',
        arriveTimeTo: '',
        arriveTimeFrom: '',
        matterIds: '',
        preStatus: '',
        startTimeFrom: '',
        startTimeTo: '',
        startUserIds: '',
        status: '1'
      }
      this.loadingAppro = true
      let response = null
      try {
        this.showBlankText = false
        if (this.isNewFirm === 'newVersion') {
          response = await Pservice.getApproListNew(params)
        } else {
          response = await Pservice.getApproListOld(params)
        }
        if (response.isSuccess) {
          if (response.data.items && response.data.items.length > 0) {
            response.data.items.map(item => {
              if (item.createDate) {
                item.createDate = timeUtils.formatTime(
                  new Date(item.createDate), 'day')
              }
              if (item.arriveCurrentNodeDate) {
                item.arriveCurrentNodeDate = timeUtils.formatTime(
                  new Date(item.arriveCurrentNodeDate), 'day')
              }
              if (item.approType && item.approTypeName) {

              } else {
                item.approTypeName = this.approListData.typeInfos[item.approType].desc
              }
            })
          } else {
            this.showBlankText = true
          }
          this.loadingAppro = false
          this.approListData = Object.assign({}, this.approListData, response.data)
        } else {
          this.loadingAppro = false
          this.$postMessage.toast({ msg: response.message || response.resultMsg })
        }
      } catch (e) {
        this.loadingAppro = false
      }
    }
  },
  mounted () {
    this.myUserId = localStorage.userid
    this.officeType = localStorage.officetype
    this.isNewFirm = localStorage.officeVersion
    this.getTaskList()
    if (this.officeType !== 'platform') {
      this.getApproList()
    }
  },
  watch: {
    '$store.state.task.effectTime' () {
      this.getTaskList()
    }
  }
}
</script>

<style lang="stylus">
.content-wrap {
  width 100%;
  box-sizing border-box;
  min-height 190px;
  background #ffffff;
  padding-top 24px;
  padding-left 24px;
  position relative;
  .today-task-create-task {
    position: absolute;
    right: 24px;
    top: 38px;
    // 加一个，不然被盖住了
    z-index: 1;
    font-size: 12px;
    color: #ed6c00;
    cursor: pointer;
    user-select: none;
    i {
      position: relative;
      top: 2px;
      margin-right: 3px;
      cursor: pointer;
    }
  }
  .el-tabs /deep/  {
    /*background-color transparent*/
    .el-tabs__header {
      .el-tabs__nav-wrap::after {
        height: 0;
      }
    }
  }
  .task-blank-text {
    width 100%
    font-size 16px;
    /*margin 0 auto;*/
  }
  .approve-blank-text {
    font-size 16px;
  }
  .more-button {
    color #8590A6;
    font-size 14px;
    cursor pointer;
    text-align center;
    padding-top 20px;
    padding-bottom 30px;
    &:hover {
      color #ed6c00
    }
    em {
      margin-left: 10px;
      tranform: rotateZ(-45deg);
      -webkit-transform: rotateZ(-45deg);
      display: inline-block;
    }
  }
}
</style>
